import type { ReactNode } from 'react';

type Props = {
  ramp?: string;
  children: ReactNode;
};

export function AppShell({ ramp, children }: Props) {
  return (
    <div className={['min-h-dvh bg-bg text-ink font-sans', ramp ? `ramp-${ramp}` : ''].join(' ')}>
      {children}
    </div>
  );
}
